const mixinSkeleton = {
  data() {
    return {
      skeletonBody: true,
    };
  },
  methods: {
    hideSkeletonBody() {
      this.skeletonBody = false;
    },

    showSkeletonBody() {
      this.skeletonBody = true;
    },

    getStateSkeletonBody() {
      return this.skeletonBody;
    },
  }
}

export default mixinSkeleton
